'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuantityProduct = undefined;

var _QuantityProduct2 = require('./QuantityProduct');

var _QuantityProduct3 = _interopRequireDefault(_QuantityProduct2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.QuantityProduct = _QuantityProduct3.default;


//////////////////
// WEBPACK FOOTER
// ./src/components/QuantityProduct/index.js
// module id = 1744
// module chunks = 0